import { API } from './constant';
import { HttpRequest } from '../../lib/http';

export const createEarning = (payload: any) => {
  return HttpRequest({
    method: API.TYPE,
    url: API.URL,
    data: payload,
  });
};
